//创建“外壳”组件
import React from "react";
import './App.css';
import { useRoutes} from "react-router-dom";
import routes from './routes';
//创建并暴露App组件
export default function App() {
  const myrouters = useRoutes(routes);
  return (
    <div className="root-div">
        {myrouters}
      </div>
  )
}